import RegistrationsProvider from './RegistrationsContext';
import Registrations from './Registrations';


let Index = () => {
    return (
        <RegistrationsProvider>
            <Registrations />
        </RegistrationsProvider>
    )
}

export default Index;